import {
  GetUserStatus,
  reqGetUserStatus,
  StatusType,
} from '@weblite/ts-action/user'
import { Message } from '@weblite/ts-action/message'
import { getClientUserId } from '$logic/client-user'
import { usersStatusStorage } from '$logic/users/user-status.storage'
import { request } from '$setup/ws'
import { getRoomFromRedux } from '$logic/room'
import { isMessageFromClientUser } from '$logic/message'
import { getPv } from '$logic/pv'
import { getUser } from '$logic/users/service'

const temporaryOnline: Record<
  string,
  { timer: ReturnType<typeof setTimeout>; value: StatusType }
> = {}

const TEMPORARY_ONLINE_DURATION = 30_000
export async function setUserStatusTemporaryOnline(userId: string) {
  const lastPatch = temporaryOnline[userId]
  if (lastPatch) clearTimeout(lastPatch.timer)
  const currentStatus = usersStatusStorage.get(userId)
  if (currentStatus === 'ONLINE' && !lastPatch) return

  const user = await getUser(userId)
  if (user.isBlocked) return

  const value =
    currentStatus === 'ONLINE' && lastPatch.value
      ? lastPatch.value
      : currentStatus

  const timer = setTimeout(
    () => usersStatusStorage.set(userId, value),
    TEMPORARY_ONLINE_DURATION,
  )
  temporaryOnline[userId] = { timer, value }
  usersStatusStorage.set(userId, 'ONLINE')
}

export async function fetchUserStatus(userId: string): Promise<void> {
  if (userId === getClientUserId()) {
    usersStatusStorage.set(userId, 'ONLINE')
    return
  }
  const res = await request<GetUserStatus>(reqGetUserStatus({ userId }))
  if (res.payload) await usersStatusStorage.set(userId, res.payload.status)
}

export function handleSeenStatusOnMessageChange(msg: Message) {
  if (
    msg &&
    getRoomFromRedux(msg.roomId).type === 'PV' &&
    !isMessageFromClientUser(msg)
  )
    getPv(msg.roomId).then(pv => setUserStatusTemporaryOnline(pv.to))
}
